import Vue from "vue";
import Router from "vue-router";
import AdminSection from "@/components/layout/AdminSection";

import * as lazy from "@/router/lazyRouteComponents";

import BrappSideNav from "@/brapp/components/layout/SideNav";
import ItrainSideNav from "@/itrain/components/layout/SideNav";
import InsightSideNav from "@/insight/components/layout/SideNav";
import SpageSideNav from "@/spage/components/layout/SideNav";
import CompanyAdminSideNav from "@/companyAdmin/components/layout/SideNav";
import SuperAdminSideNav from "@/superAdmin/components/layout/SideNav";

import MainPane from "@/components/layout/MainPane";

import brappRoutes from "./brapp/routes";
import insightRoutes from "./insight/routes";
import itrainRoutes from "./itrain/routes";
import spageRoutes from "./spage/routes";
import companyAdminRoutes from "./companyAdmin/routes";
import superAdminRoutes from "./superAdmin/routes";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/login",
      name: "login",
      component: lazy.LoginPage
    },
    {
      path: "/reset-password",
      name: "resetPassword",
      component: lazy.ResetPasswordPage
    },
    {
      path: "/reset-password-confirm/:encodedUserId/:token",
      name: "resetPasswordConfirm",
      component: lazy.ResetPasswordConfirmPage
    },
    {
      path: "",
      component: AdminSection,
      children: [
        {
          path: "/account",
          name: "userAccount",
          components: {
            main: lazy.UserAccountPage
          }
        },
        {
          path: "/company-admin",
          name: "companyAdmin",
          components: {
            main: MainPane,
            side: CompanyAdminSideNav
          },
          children: companyAdminRoutes
        },
        {
          path: "/super-admin",
          name: "superAdmin",
          components: {
            main: MainPane,
            side: SuperAdminSideNav
          },
          children: superAdminRoutes
        },
        {
          path: "/:app(brapp)",
          components: {
            main: MainPane,
            side: BrappSideNav
          },
          children: brappRoutes
        },
        {
          path: "/:app(insight)",
          components: {
            main: MainPane,
            side: InsightSideNav
          },
          children: insightRoutes
        },
        {
          path: "/:app(itrain)",
          components: {
            main: MainPane,
            side: ItrainSideNav
          },
          children: itrainRoutes
        },
        {
          path: "/:app(spage)",
          components: {
            main: MainPane,
            side: SpageSideNav
          },
          children: spageRoutes
        }
      ]
    }
  ]
});
